import { Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

interface IAccountStatementRequestModalProps {
    email: string;
    isModalOpen: boolean;
    fromDateString: string;
    toDateString: string;
    canSubmitRequest: boolean;
    modalHeaderLabel: string;
    sendToEmailLabel: string;
    fromDateLabel: string;
    toDateLabel: string;
    submitRequestLabel: string;
    cancelLabel: string;
    className: string;
    selectedUser: string;
    selectedUserLabel: string;
    toggle(): void;
    onChangeFromDate(newFromDate: string): void;
    onChangeToDate(newToDate: string): void;
    onSubmitRequest(): void;
}

export const RequestStatementModal: React.FC<IAccountStatementRequestModalProps> = ({ className, email, isModalOpen, toggle, fromDateString, toDateString, onChangeFromDate, onChangeToDate, canSubmitRequest,
        modalHeaderLabel, sendToEmailLabel, fromDateLabel, toDateLabel, submitRequestLabel, cancelLabel, onSubmitRequest, selectedUser, selectedUserLabel }) => {

    const onChangeFromDateEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        onChangeFromDate(value);
    };

    const onChangeToDateEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        onChangeToDate(value);
    };

    return (
    <Modal
        className='msc-modal-input-required'
        isOpen={isModalOpen}
        horizontalPosition={'center'}
        verticalPosition={'center'}
        autoFocus={true}
        fade={false}
        toggle={toggle}
    >
        <ModalHeader toggle={toggle}>{modalHeaderLabel}</ModalHeader>
        <ModalBody>
                <label htmlFor='sendToEmail'>{sendToEmailLabel}</label>
                <br />
                <div id='sendToEmail' className={`${className}__sendToEmail`}>{email}</div>
                {
                    selectedUser && (
                        <div>
                            {selectedUserLabel}
                            <span  className={`${className}__selectedUser`}>
                                {selectedUser}
                            </span>
                        </div>
                    )
                }
                <div>
                    <div className={`${className}__requestStatement__fromDate`}>
                        <label htmlFor='fromDateSelector'>{fromDateLabel}</label>
                        <input id='fromDateSelector' type='date' value={fromDateString} onChange={onChangeFromDateEvent} max={toDateString} className={`${className}__dateSelector form-control`}/>
                    </div>
                    <div className={`${className}__requestStatement__toDate`}>
                        <label htmlFor='toDateSelector'>{toDateLabel}</label>
                        <input id='toDateSelector' type='date' value={toDateString} onChange={onChangeToDateEvent} min={fromDateString} className={`${className}__dateSelector form-control`}/>
                    </div>
                </div>
        </ModalBody>
        <ModalFooter>
            <button className={`${className}__action__submitRequest`} onClick={onSubmitRequest} disabled={!canSubmitRequest}>{submitRequestLabel}</button>{' '}
            <button className={`${className}__action__cancelRequest`} onClick={toggle}>{cancelLabel}</button>
          </ModalFooter>
    </Modal>
    );
};